import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url


// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//data:

import { getAllTarifs } from '../../database/fetchApi.js'

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../config/api-config.js';


//Redux tools and hooks
import { useSelector, useDispatch } from "react-redux";
import { getIdSpotLoc } from "../../store/selectors.js";

//created components :
import ResaStarter from "../resastarter/ResaStarter.jsx";


//MUI
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Button, CircularProgress } from '@mui/material';
import Alert from '@mui/material/Alert';
import { TroubleshootSharp } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';

//Utils functions
import prepaMailContrat from "../../utils/prepa-mail-contrat.js" //params : fullContrat 
import prepaMail from "../../utils/prepa-mail.js" //params : fullContrat 
import calculDuree from '../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)



//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

console.log(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
dayjs.extend(isSameOrAfter)



function ModalContrat({ currentContrat, articles, accessoires, setOpen }) {

    console.log(currentContrat);
    const [retoursArticles, setRetoursArticles] = useState([]);
    const [retourAccess, setRetourAccess] = useState([]);
    const [allAccessChecked, setAllAccessChecked] = useState(false);
    const [allArticlesChecked, setAllArticlesChecked] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [retourContrat, setRetourContrat] = useState(false);
    const [resaStarter, setResaStarter] = useState(false);
    const [editContrat, setEditContrat] = useState(false); // show editing part :re send mail + modif contrat
    const [newMailConfirm, setNewMailConfirm] = useState(false); // show editing part :re send mail + modif contrat
    const [tarifs, setTarifs] = useState([]);
    const [progressMailConfirm, setProgressMailConfirm] = useState(false);

    const navigate = useNavigate();
    let idSpotLoc = useSelector(getIdSpotLoc);

    let datesContrat = [currentContrat.date1, currentContrat.date2]
    let period = [datesContrat, [currentContrat.h1, currentContrat.h2]]
    const dureeObject = calculDuree(period);

    useEffect(() => { //
        let retourAccessList = [];
        let retourArticlesList = [];

        async function initTarifs() { //we add this inner function to manage asynchrone
            let allTarifs = await getAllTarifs();
            setTarifs(allTarifs)
        } //end of async function
        initTarifs(); //call the inner asnchrone function 

        currentContrat.ContratAccesses.forEach((access) => {
            let rendusList = [];
            for (let i = 0; i < access.qte; i++) {
                rendusList.push(i >= access.rendu ? 0 : 1);
            }
            let label = accessoires.find((art) => art.id_article === access.article_id).type;

            retourAccessList.push({ id: access.id, qte: access.qte, rendus: rendusList, type: label, article_id: access.article_id })
        });
        setRetourAccess(retourAccessList)

        currentContrat.ContratArticles.forEach((article) => {
            /* let rendusList = [];
            for (let i = 0; i < article.qte; i++) {
                rendusList.push(i >= articles.rendu ? 0 : 1);
            } */
            let label = articles.find((art) => art.id_article === article.article_id).type;

            retourArticlesList.push({ id: article.id, qte: article.qte, rendus: article.rendu, type: label, article_id: article.article_id })
        });
        setRetoursArticles(retourArticlesList)


    }, [currentContrat])


    useEffect(() => { //
        if (retourContrat === true) {

            axios.put(`${baseURL}/contrat/${currentContrat.id_contrat}`, {
                retour: true
            })
                .then((response) => {
                    if (response.status === 200) { //isnertion OK
                        console.log("contrat terminé")
                    }
                })


        }


    }, [retourContrat])


    function selectAllAccess(checked) { //
        setAllAccessChecked(checked)
        let tempList = [];
        retourAccess.forEach((acc) => {
            let renduList = [];
            acc.rendus.map(rendu => {
                renduList.push(checked === true ? 1 : 0);
            })
            tempList.push({ ...acc, rendus: renduList });
        });
        setRetourAccess(tempList);
    }
    function selectAllArticles(checked) { //
        setAllArticlesChecked(checked)
        let tempList = [];
        retoursArticles.forEach((art) => {
            let renduList = [];
            art.rendus.map(rendu => {
                renduList.push(checked === true ? "1" : "0");
            })
            tempList.push({ ...art, rendus: renduList });
        });
        setRetoursArticles(tempList);
    }


    function getSpotInfos(contrat) {
        if (contrat.livraison === true) {
            return (["Livraison:", contrat.adresse_livraison]);
        }
        else {
            return ([contrat.Spot.nom_spot, contrat.Spot.adresse_spot]);
        }
    }

    function getDetailsArticles(article) {
        let details = "";
        details += String(article.qte) + " x  ";
        let typeArticle = articles.find((art) => art.id_article === article.article_id).type;
        details += typeArticle;
        return details
    }

    function getDetailsAccess(access) {
        let details = "";
        details += String(access.qte) + " x  ";
        let typeArticle = accessoires.find((art) => art.id_article === access.article_id).type;
        details += typeArticle;
        return details
    }

    function getTaillesArticles(article) {
        let tailles = "";
        article.taille.forEach((taille, index) => {
            if (taille !== "0") {
                tailles += article.prenom[index] + " : " + taille + "cm  / "
            }
        })
        return tailles
    }

    function handleCheckChange(value, index, id, mode) {

        if (mode === "accessoire") {
            let retourAccessList = retourAccess.filter(acc => acc.id !== id);
            let currentAccess = retourAccess.find(acc => acc.id === id);
            currentAccess.rendus[index] = value === true ? 1 : 0;
            retourAccessList.push(currentAccess);

            setRetourAccess(retourAccessList.toSorted((a1, a2) => a1.article_id > a2.article_id));


        } else { //modif check article
            let retourArticlesList = retoursArticles.filter(acc => acc.id !== id);
            let currentArticle = retoursArticles.find(acc => acc.id === id);
            currentArticle.rendus[index] = value === true ? "1" : "0";
            retourArticlesList.push(currentArticle);

            setRetoursArticles(retourArticlesList.toSorted((a1, a2) => a1.article_id > a2.article_id));


        }

    }

    async function validRetours() {

        let nbSuccess = 0;
        let renduFinContrat = 0

        retourAccess.forEach((access) => {
            let qte = access.rendus.filter(rendu => rendu === 1).length
            let body = { rendu: qte };
            //verify all retours?
            renduFinContrat += qte === access.qte ? 1 : 0;


            axios.put(`${baseURL}/contrat-access/${access.id}`, {
                rendu: qte
            })
                .then((response) => {
                    if (response.status === 200) { //isnertion OK
                        nbSuccess++;
                    }
                    console.log(nbSuccess, nbSuccess === retourAccess.length)
                    setShowConfirm(nbSuccess === retoursArticles.length + retourAccess.length)
                    setRetourContrat(renduFinContrat === retoursArticles.length + retourAccess.length)
                })
        })


        retoursArticles.forEach((article) => {
            let oldTaille = currentContrat.ContratArticles.find((a) => a.id === article.id).taille;
            let oldPrenom = currentContrat.ContratArticles.find((a) => a.id === article.id).prenom;

            //verify all retours?
            let qte = article.rendus.filter(rendu => rendu === "1").length
            renduFinContrat += qte === article.qte ? 1 : 0;

            axios.put(`${baseURL}/contrat-article/${article.id}`, {
                rendu: article.rendus,
                prenom: oldPrenom,
                taille: oldTaille
            })
                .then((response) => {
                    if (response.status === 200) { //isnertion OK
                        nbSuccess++;
                    }
                    console.log(nbSuccess, nbSuccess === retourAccess.length)
                    setShowConfirm(nbSuccess === retoursArticles.length + retourAccess.length)
                    setRetourContrat(renduFinContrat === retoursArticles.length + retourAccess.length)
                })
        })


    }

    function renvoieMail() {
        setProgressMailConfirm(true);

        let objetMail = currentContrat.resa === true ? "[Reservation vélos] - contrat location " + currentContrat.ref_contrat : "[Début Location] -  " + currentContrat.ref_contrat;
        let bodyMail = currentContrat.resa === true ? prepaMail(currentContrat, articles, dureeObject, tarifs) : prepaMailContrat(currentContrat, articles, accessoires, dureeObject, tarifs);

        let body = {
            //to: "manuel.vivion@gmail.com",
            to: currentContrat.Client.email,
            bcc: "sylvainboufflers2@gmail.com,manuel.vivion@gmail.com",
            subject: objetMail,
            html: bodyMail
        };

        axios.post(`${baseURL}/mailing/mail-confirm`, body)
            .then((response) => {

                if (response.status === 200) { //isnertion OK
                    setNewMailConfirm(true);
                    setProgressMailConfirm(false);
                }
                else { //insertion problème

                    console.log("erreur Mail")
                }
            })
            .catch(error => {
                //// ---
                return error

            })



    }

    function goToEdit() {
        // reset redux ?

        navigate("/manager/editcontrat/" + currentContrat.id_contrat + "/" + currentContrat.ref_contrat);
    }

    function goToEditResa() {
        // reset redux ?

        navigate("/manager/modifresa/" + currentContrat.id_contrat + "/" + currentContrat.ref_contrat);
    }


    return (
        <div className="modal-contrat">
            <div className="modal-contrat-top">
                <span className="modal-contrat-top-bt-close" onClick={_ => setOpen(false)}><CloseIcon /></span>
                <div className="modal-contrat-top-ligne1">
                    <h4>{"Contrat : " + currentContrat.ref_contrat} </h4>
                    {currentContrat.resa === true ? <p> (Réservation en ligne)</p> : null}
                    <span className="modal-contrat-top-bt-edit" onClick={_ => setEditContrat(!editContrat)}><EditIcon /></span>

                </div>
                {editContrat === true ?
                    <div className="modal-contrat-top-edit">
                        <div className="modal-contrat-top-edit-mail">
                            <p onClick={_ => renvoieMail()}>Renvoyer le mail de confirmation</p>
                            {newMailConfirm === true ? <CheckIcon className="modal-contrat-top-edit-mail-ok" /> : null}
                            {progressMailConfirm === true ? <CircularProgress /> : null}
                        </div>

                        {currentContrat.resa === true && dayjs(currentContrat.date1).isAfter(dayjs()) ?// when resa is not started yet
                            <Button
                                variant="contained"
                                onClick={_ => goToEditResa()}
                            >
                                modifier Résa
                        </Button>
                            : null}



                        <Button
                            variant="contained"
                            disabled={currentContrat.garantie.length === 0 || currentContrat.spot_id !== idSpotLoc || currentContrat.retour === true}
                            onClick={_ => goToEdit()}
                        >
                            modifier contrat
                        </Button>


                    </div>
                    : null}
                <div className="modal-contrat-top-dates">
                    <p>{dayjs(currentContrat.date1).format("dddd DD MMMM YY") + " à "} <b>{currentContrat.h1 + "h00"}</b></p>
                    <div className="modal-contrat-top-dates-lien"></div>
                    <p>{dayjs(currentContrat.date2).format("dddd DD MMMM YY") + " à "} <b>{currentContrat.h2 + "h00"}</b></p>
                </div>

            </div>
            <div className="modal-contrat-middle">
                <div className="modal-contrat-middle-spot">
                    <h5>Point de location :</h5>
                    <p>{getSpotInfos(currentContrat)[0]}</p>
                    <p>{getSpotInfos(currentContrat)[1]}</p>
                </div>
                <div className="modal-contrat-middle-client">
                    <h5>Client :</h5>
                    <p>{currentContrat.Client.prenom + " " + currentContrat.Client.nom} ({currentContrat.Client.id_client})</p>
                    <p>{currentContrat.Client.tel} </p>
                    <p>{currentContrat.Client.email}</p>
                    <p>{currentContrat.Client.adresse}</p>
                    <p>{currentContrat.Client.adresse_comp}</p>
                    <p>{currentContrat.Client.cp}, {currentContrat.Client.ville}, {currentContrat.Client.country} </p>
                </div>
            </div>
            <div className="modal-contrat-bottom">
                <p>{"Réservation faite le :" + dayjs(currentContrat.date_crea).format("DD/MM/YYYY")}</p>
                <h5>{"Montant total de la résa : " + currentContrat.total + ",00€"}</h5>
                {currentContrat.retour === true ?
                    <h5 className="modal-contrat-bottom-retour"><CheckIcon />Contrat terminé (articles rendus)</h5>
                    : null}
                {currentContrat.garantie.length > 0 ?
                    <h5 className="modal-contrat-bottom-garantie">{"Dépot de garantie : " + currentContrat.garantie}</h5>
                    : null}

                {currentContrat.garantie.length > 0 ?
                    currentContrat.retour === true ?
                        <div className="modal-contrat-bottom-articles">

                            <h4>Liste des articles : </h4>
                            {
                                currentContrat.ContratArticles.map((article) => (
                                    <div key={article.id} className="modal-contrat-bottom-articles-item">
                                        <p>{getDetailsArticles(article)}</p>
                                        <p>{getTaillesArticles(article)}</p>
                                    </div>
                                ))
                            }
                        </div>
                        :
                        <div className="modal-contrat-bottom-articles">
                            <div className="modal-contrat-bottom-articles-retour-header">
                                <h4>Liste des articles en cours: </h4>
                                <FormControlLabel
                                    control={<Checkbox
                                        onChange={e => selectAllArticles(e.target.checked)}
                                        checked={allArticlesChecked}
                                    />}
                                    label="tout cocher"
                                />
                            </div>
                            {
                                retoursArticles.map((retour) => (
                                    <div key={retour.id} className="modal-contrat-bottom-articles-loc-item">
                                        <p>{retour.qte} x {retour.type}</p>
                                        <div key={retour.id} className="modal-contrat-bottom-articles-loc-item-infos">
                                            {retour.rendus.map((rendu, index) => (
                                                <FormControlLabel
                                                    key={index}
                                                    className="manager-jour-top-spot-checkbox"
                                                    style={{
                                                        color: rendu === "1" ? "#6BBDB1" : "black",
                                                    }}
                                                    /* required */
                                                    control={<Checkbox
                                                        style={{
                                                            color: rendu === "1" ? "#6BBDB1" : "black",
                                                        }}
                                                        onChange={e => handleCheckChange(e.target.checked, index, retour.id, "article")}
                                                        checked={rendu === "1"}
                                                    />}
                                                    label="rendu"

                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                    :
                    <div className="modal-contrat-bottom-articles">

                        <h4>Liste des articles : </h4>
                        {
                            currentContrat.ContratArticles.map((article) => (
                                <div key={article.id} className="modal-contrat-bottom-articles-item">
                                    <p>{getDetailsArticles(article)}</p>
                                    <p>{getTaillesArticles(article)}</p>
                                </div>
                            ))
                        }
                    </div>
                }

                {currentContrat.garantie.length > 0 ?
                    currentContrat.retour === true ?
                        <div className="modal-contrat-bottom-articles">
                            <h4>Liste des accessoires : </h4>
                            {
                                currentContrat.ContratAccesses.map((article) => (
                                    <div key={article.id} className="modal-contrat-bottom-articles-item">
                                        <p>{getDetailsAccess(article)}</p>
                                    </div>
                                ))
                            }
                        </div> :
                        <div className="modal-contrat-bottom-articles">
                            <div className="modal-contrat-bottom-articles-retour-header">
                                <h4>Liste des accessoires en cours: </h4>
                                <FormControlLabel
                                    control={<Checkbox
                                        onChange={e => selectAllAccess(e.target.checked)}
                                        checked={allAccessChecked}
                                    />}
                                    label="tout cocher"
                                />
                            </div>
                            {
                                retourAccess.map((retour) => (
                                    <div key={retour.id} className="modal-contrat-bottom-articles-loc-item">
                                        <p>{retour.qte} x {retour.type}</p>
                                        <div key={retour.id} className="modal-contrat-bottom-articles-loc-item-infos">
                                            {retour.rendus.map((rendu, index) => (
                                                <FormControlLabel
                                                    key={index}
                                                    className="manager-jour-top-spot-checkbox"
                                                    style={{
                                                        color: rendu === 1 ? "#6BBDB1" : "black",
                                                    }}
                                                    /* required */
                                                    control={<Checkbox
                                                        style={{
                                                            color: rendu === 1 ? "#6BBDB1" : "black",
                                                        }}
                                                        onChange={e => handleCheckChange(e.target.checked, index, retour.id, "accessoire")}
                                                        checked={rendu === 1}
                                                    />}
                                                    label="rendu"

                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                    :
                    null
                }


                {currentContrat.garantie.length > 2 && currentContrat.retour === false ?
                    <div className="modal-contrat-bottom-articles-bouton">
                        <Button
                            variant="contained"
                            onClick={_ => validRetours()}>
                            Valider les retours
                    </Button>
                        {showConfirm === true ?
                            <Alert
                                className="step5-bottom-alert"
                                severity="success">
                                Les retours articles et accessoires ont bien été enregistrés
                        </Alert>
                            : null
                        }
                        {retourContrat === true ?
                            <Alert
                                className="step5-bottom-alert"
                                severity="success">
                                Tous les articles et accessoires ont été rendus. Le contrat est terminé
                        </Alert>
                            : null
                        }
                    </div>
                    : null}

                <div className="resa-starter-bottom">

                    {resaStarter === false && currentContrat.resa === true && currentContrat.garantie.length === 0 && dayjs().isSameOrAfter(dayjs(currentContrat.date1), "day") ?
                        <Button
                            variant="contained"
                            onClick={_ => setResaStarter(!resaStarter)}>
                            Démarrer la location
                </Button>
                        : null}
                    {resaStarter === true ?
                        <ResaStarter currentContrat={currentContrat} accessoires={accessoires} articles={articles} />
                        : null}

                </div>
                {currentContrat.commentaire.length > 2 ?
                    <div className="modal-contrat-bottom-commentaire">
                        <h4>Commentaire :</h4>
                        <p>{currentContrat.commentaire}</p>
                    </div>
                    : null}
                {currentContrat.commentaire2.length > 2 ?
                    <div className="modal-contrat-bottom-commentaire">
                        <h4>Commentaire 2 :</h4>
                        <p>{currentContrat.commentaire2}</p>
                    </div>
                    : null}

            </div>
        </div>
    );
}

export default ModalContrat